'use client';

import { Spinner as HeroSpinner } from '@heroui/react';

export interface SpinnerProps {
  color?:
    | 'danger'
    | 'current'
    | 'accent'
    | 'success'
    | 'warning'
    | 'default'
    | 'primary'
    | 'secondary';
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

export const Spinner = ({
  color = 'accent',
  size = 'md',
  label,
}: SpinnerProps) => {
  // @ts-ignore
  return <HeroSpinner color={color} size={size} label={label} />;
};
